export default __webpack_public_path__ + "static/media/rmperformance_icon.85dc710a.svg";